import Skeleton from "react-loading-skeleton";
import { formatNumberWithComma } from "../../utils/functions/formatters";
import { useStore } from "../../store/useStore";
import { INFRACTION_DATE_TYPES } from "../../utils/constants/constants";

interface InfractionCardProps {
  title: string;
  color?: string;
  value?: string;
  percentageDifference: number | null;
  information?: string;
  loading: boolean;
  className?: string;
}

const InfractionCard: React.FC<InfractionCardProps> = ({ title, value, color, percentageDifference, information, loading, className }) => {
    const selectedDateType = useStore((state) => state.infraction.selectedDateType);
  return (
    <>
      <div className={`${className} shadow-base rounded-[12px] bg-white pt-4 w-full`}>
        <div className="border-gray_2 pl-2 mb-5 mt-2 ml-4" style={{borderLeftWidth: 4, borderColor: color}}>
          <div className="font-light text-base text-gray_2">
            {title}
          </div>
          {!loading ? (
              <div className="font-bold text-3xl color-[#344767]">
                {value != '0' ? formatNumberWithComma(value) : '0'}
              </div>
            ) : null}
          {loading && <div className="pr-4"><Skeleton className="w-full" /> </div>}
        </div>
        
        <div className="border-t border-gray_08 px-5 py-3">
          {!loading ? (
              <div>
                <span className={`${percentageDifference && percentageDifference < 0 ? 'text-green' : 'text-red'} font-bold`}>{percentageDifference ? `${percentageDifference > 0 ? '+' : ''}${percentageDifference?.toFixed(2).replace(".", ",")}%` : '0%' }</span>
                <span className="font-light text-md text-gray_2"> em relação 
                  {selectedDateType === INFRACTION_DATE_TYPES[0].value ? " a dia anterior" : " ao mês anterior"}
                </span>
              </div>
            ) : null}
          {loading && <Skeleton className="w-full" />}
        </div>
      </div>
    </>
  );
};

export default InfractionCard;
